import React from 'react';

import ConnectWithAlumniButton from '@alumni_v2/ui/ConnectWithAlumniButton';

import newIcon from '@alumni_v2/images/webp/newIcon.webp';
import powerIcon from '@alumni_v2/images/svg/powerIcon.svg';

import styles from './AlumniConnectBox.module.scss';

const AlumniConnectBox = ({
  name, setSidebarModalStage, onModalClose, userId,
}) => (
  <div className={styles.askQuestionContainer}>
    <div className={styles.qNaTopSection}>
      <div className={styles.qNaHeading}>
        <img src={powerIcon} alt="powerIcon" className={styles.powerIcon} />
        <div>Connect 1-1 with Alumni</div>
        <img src={newIcon} alt="newIcon" className={styles.newIcon} />
      </div>
      <div className={styles.qNaSubHeading}>
        Get on a 1-1 call with the alumni and resolve all your queries
        regarding career advice, industry insights, Scaler experience and more
      </div>
    </div>
    <ConnectWithAlumniButton
      name={name}
      className={styles.qNaButton}
      setSidebarModalStage={setSidebarModalStage}
      onModalClose={onModalClose}
      userId={userId}
    >
      Request for 1-1 Alumni Session
    </ConnectWithAlumniButton>
  </div>
);

export default AlumniConnectBox;
